import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/lib/Async";
import { fetchJson } from "../../lib/Fetching";

export default class AccreditationInput extends React.Component {
  fetchData = search =>
    fetchJson("/accreditations.json", { search }).then(records =>
      records.map(m => ({ label: m.name, value: m.id }))
    );

  customStyles = () => {
    const { width } = this.props;
    return {
      control: (base, state) => ({
        ...base,
        width: width || 300
      })
    };
  };

  render() {
    const { onChange, multiple } = this.props;
    return (
      <AsyncSelect
        placeholder={multiple ? "Select Accreditations" : "Select Accreditation"}
        isMulti={multiple}
        simpleValue={true}
        autoload={true}
        styles={this.customStyles()}
        id="testname_id"
        loadOptions={this.fetchData}
        onChange={onChange}
      />
    );
  }
}
